export default __webpack_public_path__ + "static/media/router.397349a1.png";